import quoteProgress from './quote-progress';

const quotingNavHeight = 77;

export default {
  padding: {
    vertical: '1.125rem',
    horizontal: '0',
  },
  zIndex: 100,
  inner: {
    mobile: {
      padding: {
        left: '0.9375rem',
      },
    },
  },
  actions: {
    minHeight: '2.9375rem',
    child: {
      last: {
        mobile: {
          margin: {
            right: '0.625rem',
          },
        },
      },
    },
  },
  drawer: {
    padding: {
      top: '0',
      right: '0.9375rem',
      bottom: '0.9375rem',
      left: '0.9375rem',
    },
    width: '15.625rem',
    left: '0',
    links: {
      margin: {
        top: '0.9375rem',
        bottom: '0.9375rem',
      },
      border: {
        style: 'solid',
        thickness: '0.03125rem',
      },
    },
    link: {
      margin: {
        bottom: '0.9375rem',
      },
      padding: {
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
      },
    },
    hamburger: {
      margin: {
        right: '1.25rem',
      },
      height: '1.5rem',
      width: '1.5rem',
    },
  },
  links: {
    margin: {
      left: '1.875rem',
    },
  },
  link: {
    child: {
      not: {
        last: {
          margin: {
            right: '0rem',
          },
        },
      },
    },
    accessibleToggle: {
      padding: {
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
      },
    },
    dropdown: {
      left: '-1.875rem',
      width: '13.75rem',
      padding: {
        top: '1.875rem',
        right: '1.875rem',
        bottom: '1.875rem',
        left: '1.875rem',
      },
      mobile: {
        padding: {
          top: '1.125rem',
          right: '1.125rem',
          bottom: '0',
          left: '1.125rem',
        },
      },
      link: {
        child: {
          not: {
            last: {
              mobile: {
                margin: {
                  bottom: '0.9375rem',
                },
              },
              margin: {
                bottom: '1.25rem',
              },
            },
          },
        },
      },
    },
  },
  logo: {
    colour: '#FFFFFF',
    width: '114px',
    mobile: {
      width: '82px',
    },
  },
  subnav: {
    margin: {
      bottom: '1.25rem',
    },
    link: {
      not: {
        child: {
          last: {
            margin: {
              right: '0.9375rem',
            },
          },
        },
      },
    },
  },
  search: {
    icon: {
      margin: {
        right: '0.3125rem',
      },
    },
    width: '.75rem',
  },
  searchBar: {
    padding: {
      top: '0.625rem',
      right: '0.625rem',
      bottom: '0.625rem',
      left: '0.625rem',
    },
    border: {
      style: 'solid',
      thickness: '0.03125rem',
    },
    width: '50rem',
    input: {
      margin: {
        right: '0.9375rem',
      },
      padding: {
        top: '0.75rem',
        right: '0.75rem',
        bottom: '0.75rem',
        left: '3rem',
      },
      border: {
        radius: '50px',
        style: 'solid',
        thickness: '0.0625rem',
        focused: {
          style: 'solid',
          thickness: '0.25rem',
        },
      },
    },
    results: {
      border: {
        style: 'solid',
        thickness: '0.0625rem',
        radius: {
          topLeft: '1.5625rem',
          topRight: '1.5625rem',
          bottomLeft: '0',
          bottomRight: '0',
        },
      },
      padding: {
        top: '1.25rem',
        right: '1.25rem',
        bottom: '1.25rem',
        left: '1.25rem',
      },
    },
    icon: {
      width: '1.25rem',
      left: '1.25rem',
    },
    back: {
      margin: {
        bottom: '0.75rem',
      },
      rotation: '180deg',
    },
    close: {
      width: '1.1875rem',
    },
  },
  button: {
    icon: {
      width: '2.1875rem',
      height: '2.1875rem',
      small: {
        width: '0.75rem',
        height: '0.75rem',
      },
    },
  },
  iconContainer: {
    width: '0.75rem',
    margin: {
      right: '0.5rem',
    },
  },
  checkout: {
    height: `${quotingNavHeight}px`,
    zIndex: '10',
  },
  navProgressHeight: `${
    quotingNavHeight + parseInt(quoteProgress.minHeight.replace('px', ''))
  }px`,
};
